// eslint-disable-next-line no-restricted-imports
import styled from '@emotion/styled';
import { ChevronRightIcon, Typography } from '@iheartjane/reefer';
import type { MarginProperties } from '@iheartjane/reefer';
import { darken } from 'polished';

import type { RootLoaderType } from '@jane/kiosk/data-access';
import { useTypedRouteLoaderData } from '@jane/kiosk/hooks';
import { trackSignInTap } from '@jane/kiosk/util';
import { useGetStore } from '@jane/shared/data-access';
import type { Store } from '@jane/shared/types';

import { StyledButton } from '../StoreSwitcher/StoreSwitcher';

const StyledSignInButton = styled(StyledButton)<{
  isJaneMode: boolean;
  location: string;
}>(({ isJaneMode, location, theme }) => {
  const color = darken(
    0.05,
    location === 'special'
      ? theme.colors.brand.sunset.main
      : location === 'brandSpecial'
        ? theme.colors.brand.gold.main
        : location === 'featured' || isJaneMode
          ? theme.colors.grays.ultralight
          : theme.colors.primary.main
  );

  return {
    backgroundColor: color,
  };
});

export const SignInButton = ({
  isJaneMode = false,
  location,
  onLoginIconClick,
  ...spacingProps
}: {
  isJaneMode?: boolean;
  location: string;
  onLoginIconClick: () => void;
} & MarginProperties) => {
  const { store: initialStore, storeId } =
    useTypedRouteLoaderData<RootLoaderType>('root');
  const { data: store } = useGetStore<Store>(storeId, {
    initialData: initialStore,
  });

  const textColor =
    location === 'featured' || isJaneMode
      ? 'grays-mid'
      : location === 'brandSpecial'
        ? 'grays-black'
        : 'text-info';

  const handleLoginClick = () => {
    trackSignInTap({
      store,
      source: ['Menu'],
    });
    onLoginIconClick();
  };

  return (
    <StyledSignInButton
      location={location}
      isJaneMode={isJaneMode}
      size="small"
      label={
        <Typography variant="small-body-semibold" color={textColor}>
          Tap to sign in
        </Typography>
      }
      endIcon={<ChevronRightIcon size="sm" color={textColor} />}
      onClick={handleLoginClick}
      {...spacingProps}
    />
  );
};
